import React from 'react';
import styled from 'styled-components';
import { colors } from '../../tailwind';

const BackgroundContainer = styled.div`
  background-color: ${colors.background};
  width: 100%;
  height: 100%;
  padding: 48px 0px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export default BackgroundContainer;



// WEBPACK FOOTER //
// ./src/components_new/common/BackgroundContainer.js